import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { ApiOrder, CreateOrderRequest, QueryOrdersParams, UpdateOrderStatusRequest } from '@core/models/api/order.model';

@Injectable({
  providedIn: 'root'
})
export class OrdersApiService {
  private http = inject(HttpClient);
  private baseUrl = `${environment.apiBaseUrl}/orders`;

  getAll(query?: QueryOrdersParams): Observable<ApiOrder[]> {
    let params = new HttpParams();
    if (query?.search) {
      params = params.set('search', query.search);
    }
    if (query?.status) {
      params = params.set('status', query.status);
    }
    return this.http.get<ApiOrder[]>(this.baseUrl, { params });
  }

  getById(id: string): Observable<ApiOrder> {
    return this.http.get<ApiOrder>(`${this.baseUrl}/${id}`);
  }

  create(payload: CreateOrderRequest): Observable<ApiOrder> {
    return this.http.post<ApiOrder>(this.baseUrl, payload);
  }

  updateStatus(id: string, payload: UpdateOrderStatusRequest): Observable<ApiOrder> {
    return this.http.patch<ApiOrder>(`${this.baseUrl}/${id}/status`, payload);
  }

  delete(id: string): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/${id}`);
  }
}
